import { CanActivateFn, Router } from '@angular/router';
import { StoreService } from '../services/store.service';
import { inject } from '@angular/core';
import { Authority } from '../../features/login-page/login-response.model';
import { Contract } from '../../features/contracts/select-contract/contracts.model';
import { Language } from '../models/language.model';

export const isAuthenticatedGuard: CanActivateFn = (route, state) => {
  const storeService = inject(StoreService);
  const router = inject(Router);

  if (!storeService.isLogged) {
    storeService.isLogged = localStorage.getItem('isLogged') === 'true';
  }
  if (!storeService.isContractSelected) {
    storeService.isContractSelected = localStorage.getItem('isContractSelected') === 'true';
  }
  if (!storeService.contracts || storeService.getContracts().length === 0) {
    storeService.contracts = JSON.parse(localStorage.getItem('contracts') ?? '[]') as Contract[];
  }
  if (!storeService.authorities || storeService.getAuthorities().length === 0) {
    storeService.authorities = JSON.parse(localStorage.getItem('authorities') ?? '[]') as Authority[];
  }
  if (storeService.isLogged && storeService.isContractSelected) {
    if (Object.keys(storeService.selectedLanguage()).length === 0) {
      storeService.selectLanguage(JSON.parse(localStorage.getItem('selectedLanguage') ?? '{}') as Language);
    }

    if (Object.keys(storeService.selectedContract()).length === 0) {
      storeService.setSelectedContract(JSON.parse(localStorage.getItem('selectedContract') ?? '{}') as Contract);
    }
  }
  localStorage.setItem('selectedLanguage', JSON.stringify(storeService.selectedLanguage()));
  localStorage.setItem('selectedContract', JSON.stringify(storeService.selectedContract()));
  localStorage.setItem('contracts', JSON.stringify(storeService.contracts));
  localStorage.setItem('authorities', JSON.stringify(storeService.authorities));

  const result = storeService.isLogged && storeService.isContractSelected;
  if (!result) {
    router.navigate(['/login']);
  }
  return result;
};
